import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import {
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Drawer,
  IconButton,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Collapse from "@mui/material/Collapse";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AbcIcon from "@mui/icons-material/Abc";
import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link as RouterLink } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

export const BlocksUpdatePage = (props) => {
  const [open, setOpen] = useState(true);
  const [blocksOpen, setBlocksOpen] = useState(true);
  const [menu, setMenu] = useState(false);
  return (
    <div className="get-started-page">
      <header className="topbar">
        <IconButton
          className="menu-button"
          onClick={() => {
            setMenu(true);
          }}
        >
          <MenuIcon />
        </IconButton>
        <div className="topbar-logo">
          <a href="https://www.fabloq.com">
            <div class="surface">
              <p class="f-letter">F</p>
              <div class="block"></div>
            </div>
          </a>
        </div>
        <span className="topbar-docs">Docs</span>
      </header>

      <main className="content">
        <Drawer
          open={menu}
          onClose={() => {
            setMenu(false);
          }}
          className="drawer"
        >
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </Drawer>
        <div className="sidebar" style={{ height: window.innerHeight - 55 }}>
          <List
            sx={{
              width: "100%",

              bgcolor: "background.paper",
            }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            // subheader={
            //   <ListSubheader component="div" id="nested-list-subheader">
            //     Nested List Items
            //   </ListSubheader>
            // }
          >
            <ListItemButton component={RouterLink} to="/getstarted">
              <ListItemIcon>
                <AbcIcon color="#ff5757" />
              </ListItemIcon>
              <ListItemText primary="Get Started" />
            </ListItemButton>
            <ListItemButton
              onClick={() => {
                setBlocksOpen(!blocksOpen);
              }}
            >
              <ListItemIcon>
                <CodeIcon />
              </ListItemIcon>
              <ListItemText primary="Blocks" />
              {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={blocksOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/overview"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Overview" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Control Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/variables"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Variable" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/response"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Response" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/if"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="If" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/loop"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Loop" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Database Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchone"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch One" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/fetchmany"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Fetch Many" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/create"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Create" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/update"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Update" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/delete"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="Delete" />
                </ListItemButton>
                <ListSubheader component="div" id="nested-list-subheader">
                  Authentication Blocks
                </ListSubheader>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignup"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Signup" />
                </ListItemButton>
                <ListItemButton
                  sx={{ pl: 4 }}
                  component={RouterLink}
                  to="/blocks/usersignin"
                >
                  {/* <ListItemIcon>
                      <StarBorder />
                    </ListItemIcon> */}
                  <ListItemText primary="User Sign In" />
                </ListItemButton>
              </List>
            </Collapse>
            {/* <ListItemButton>
              <ListItemIcon>
                <StorageIcon />
              </ListItemIcon>
              <ListItemText primary="Database" />
            </ListItemButton>
            <ListItemButton>
              <ListItemIcon>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItemButton> */}
          </List>
        </div>
        <div className="article">
          <div className="article-left" />
          <div className="article-content">
            <h2 className="topic-title" id="update-block">
              <span className="hashtag">#</span> Update Block
            </h2>
            <p className="topic-para">
              Update block is used to modify data on the database table. It
              stores the result in a variable as a dictionary.
            </p>
            <h2 className="topic-title" id="how-to-create-update-block">
              <span className="hashtag">#</span> How to create a Update Block
            </h2>
            <ol>
              <li className="topic-para">
                Select “Update” under “Database Blocks” in Add a block dialog.
              </li>
              <li className="topic-para">
                Enter name of the variable which has the database data to be
                modified.
              </li>
              <li className="topic-para">
                Click on plus icon to add data to different fields of table.
              </li>
              <li className="topic-para">
                Enter the database table field name and desired value.
              </li>
              <li className="topic-para">
                Enter the database table field name and desired value.
              </li>
              <li className="topic-para">Click on Add to create the block.</li>
            </ol>
            <div className="topic-footline"></div>
            <div className="topic-buttons">
              <Button component={RouterLink} to="/blocks/create">
                <ChevronLeftIcon /> Create
              </Button>
              <Button component={RouterLink} to="/blocks/delete">
                Delete <ChevronRightIcon />
              </Button>
            </div>
          </div>
          <div className="article-right" />
        </div>
        <div className="index">
          <a className="index-title">Contents</a>
          <a className="index-topic" href="#update-block">
            Update Block
          </a>
          <a className="index-topic" href="#how-to-create-update-block">
            How to create a Update Block
          </a>
          {/* <div className="index-sublist">
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
              <p className="index-subtopic">Sub Topic</p>
            </div> */}
        </div>
      </main>
    </div>
  );
};
